
import { useCompany } from '@/hooks/use-company';

// Re-export company data for backward compatibility with branding
export function useBranding() {
  const { company, logoUrl, primaryColor, updateCompany, isLoading, fetchCompany } = useCompany();
  
  return {
    logoUrl,
    primaryColor,
    branding: company,
    isLoading,
    fetchBranding: fetchCompany,
    updateBranding: updateCompany
  };
}
